import { stats } from '@fiverr-private/obs';

export const prefixedStats = stats.prefix('services.tailored_homepage_perseus');
export const metricsService = {
    count(metric: string, value = 1) {
        return prefixedStats.count(metric, value);
    },
    time(metric: string, value: number) {
        return prefixedStats.time(metric, value);
    },
};
